import { api } from './api';

export interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'assistant';
  timestamp: Date;
  data?: any;
  displayType?: string;
  actions?: Array<{ type: string; label: string }>;
}

export interface AiResponse {
  intent: {
    category: string;
    action: string;
    entities: Record<string, any>;
    confidence: number;
  };
  response: {
    text: string;
    type: string;
    data: any;
    displayType?: string;
    actions?: Array<{ type: string; label: string }>;
  };
  timestamp: Date;
}

class AiAssistantService {
  async sendMessage(message: string): Promise<AiResponse> {
    try {
      const response = await api.post('/ai-assistant/chat', { message });
      return response.data;
    } catch (error) {
      console.error('Error sending message to AI assistant:', error);
      throw new Error('Failed to send message to AI assistant');
    }
  }

  async getSuggestions(): Promise<string[]> {
    try {
      const response = await api.get('/ai-assistant/suggestions');
      return response.data;
    } catch (error) {
      console.error('Error getting AI suggestions:', error);
      return [
        "Show me low stock items",
        "What are my sales this month?",
        "Dashboard summary",
        "List top customers",
        "Show work orders"
      ];
    }
  }

  // Helper method to format currency for display
  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }

  // Helper method to format numbers for display
  formatNumber(num: number): string {
    return new Intl.NumberFormat('en-IN').format(num);
  }
}

export const aiAssistantService = new AiAssistantService();